import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { Alert, Button, Modal, Table } from '@itds/elements';

import EditFactorDrawer from '@carrier/pages/carriers/life_quotes/modal_factors/Edit';

import Api from '@carrier/utils/Api';

const List = () => {
  const params = useParams();

  const [factors, setFactors] = useState([]);
  const [factor, setFactor] = useState(null);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadModalFactors();
  }, []);

  const loadModalFactors = action => {
    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadModalFactors({ carrier_id: params.id, data_version_id: params.version_id })
      .then(({ data }) => {
        setFactors(data);
        if (action === 'add') {
          setSuccessMessage('Modal Factor Successfully Added');
        } else if (action === 'delete') {
          setSuccessMessage('Modal Factor Successfully Deleted');
        }
      })
      .catch(() => {
        if (action === 'add') {
          setErrorMessage('Unable to add Modal Factor at this time');
        } else if (action === 'delete') {
          setErrorMessage('Unable to delete Modal Factor at this time');
        }
      });
  };

  const handleSave = () => {
    setFactor(null);
    loadModalFactors('add');
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteModalFactor(deleteInfo.id)
      .then(() => {
        loadModalFactors('delete');
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return (
    <>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <EditFactorDrawer
        factor={factor}
        onClose={setFactor.bind(null, null)}
        onSave={handleSave}
        show={!!factor}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setFactor.bind(null, {
            carrier_id: params.id,
            data_version_id: params.version_id
          })}
        >
          Add Modal Factor
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'annual_factor',
            label: 'Annual'
          },
          {
            id: 'semi_annual_factor',
            label: 'Semi-Annual'
          },
          {
            id: 'quarterly_factor',
            label: 'Quarterly'
          },
          {
            id: 'monthly_factor',
            label: 'Monthly'
          },
          {
            id: 'updated_at',
            label: 'Last Updated',
            render: factor => format(new Date(factor.updated_at), 'MM/dd/yyyy')
          },
          {
            id: 'actions',
            render: row => {
              return (
                <div>
                  <Button
                    color='RED'
                    inline={true}
                    onClick={handleDelete.bind(null, row)}
                    small={true}
                  >
                    Delete
                  </Button>
                </div>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={factors}
        onRowClick={setFactor}
      />
      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.name}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default List;
